function toggleTabs(isUnhealthy) {
    var healthyTab = document.getElementById("healthy");
    var unhealthyTab = document.getElementById("unhealthy");
    var healthyBlocks = document.querySelector(".TabbedRelationships-blocks.healthy-active");
    var unhealthyBlocks = document.querySelector(".TabbedRelationships-blocks.unhealthy-active");

    if (isUnhealthy) {
        unhealthyTab.classList.add("active");
        healthyTab.classList.remove("active");
        healthyBlocks.style.display = "none";
        unhealthyBlocks.style.display = "flex";
    } else {
        healthyTab.classList.add("active");
        unhealthyTab.classList.remove("active");
        healthyBlocks.style.display = "flex";
        unhealthyBlocks.style.display = "none";
    }
}